import styled, { css } from "styled-components";

export const AccountDetailsContainer = styled.div`
  margin-bottom: 24px;
`;

export const StrategyDetailsContainer = styled(AccountDetailsContainer)`
  padding: 20px 0px 0px;
  * {
    box-shadow: none;
  }

  .table-container {
    border: 1px solid #e9eaeb;
  }
`;

export const MetricItem = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e9eaeb;
  margin-bottom: 15px;
  box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05);
  display: flex;
  flex-direction: column;
  gap: 12px;

  .metric-heading {
    color: #181d27;
    font-family: "Geist", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5em;
    margin: 0;
  }

  .metric-content {
    display: flex;
    align-items: flex-end;
    gap: 16px;

    .metric-left {
      display: flex;
      flex-direction: column;
      gap: 12px;
      flex: 1;

      .metric-value {
        color: #181d27;
        font-family: "Aeonik", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.33em;
        margin: 0;

        .metric-value-decimal {
          font-size: 16px;
          line-height: 1;
          vertical-align: super;
          padding-left: 2px;
        }
      }

      .metric-change {
        display: flex;
        align-items: center;
        gap: 8px;

        .change-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2px;

          .arrow-icon {
            width: 16px;
            height: 16px;

            svg {
              width: 9.33px;
              height: 9.33px;
              stroke: #17b26a;
              stroke-width: 2px;
            }
          }

          .change-percentage {
            color: #079455;
            font-family: "Public Sans", sans-serif;
            font-weight: 500;
            font-size: 14px;
            line-height: 1.43em;
            margin: 0;
          }
        }

        .change-text {
          color: #535862;
          font-family: "Public Sans", sans-serif;
          font-weight: 500;
          font-size: 14px;
          line-height: 1.43em;
          margin: 0;
        }
      }
    }

    .metric-chart {
      width: 112px;
      height: 56px;
      position: relative;

      .chart-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 1px;
      }

      .chart-line {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        svg {
          width: 100%;
          height: 100%;

          path {
            stroke-width: 2px;
            fill: none;
          }
        }
      }

      .chart-marker {
        position: absolute;
        top: 7px;
        right: 46px;
        width: 19.25px;
        height: 19.25px;

        .marker-ring {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 2px solid #17b26a;
          border-radius: 50%;
          opacity: 0.2;
        }

        .marker-dot {
          position: absolute;
          top: 4.38px;
          left: 4.38px;
          width: 10.5px;
          height: 10.5px;
          background: #ffffff;
          border: 2px solid #17b26a;
          border-radius: 50%;
        }
      }
    }
  }
`;

export const AccountDetailsContainer2 = styled.div`
  background: ${({ theme }) => theme.card.bg.secondary};
  border-radius: 10px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.card.border.quaternary};
  margin-bottom: 15px;

  .dashboard-item {
    .label {
      display: flex;
      gap: 8px;

      p {
        margin: 0px;
        color: ${({ theme }) => theme.card.font.secondary};
        font-size: 14px;
        font-weight: 400;
      }
    }

    .value {
      color: ${({ theme }) => theme.card.font.tertiary};
      font-size: 30px;
      font-weight: 400;
      display: flex;
    }

    span {
      color: #888;
    }
  }

  .separator {
    border-right: 1px solid #e3e3e8;
  }

  .active-strategies {
    border: 0px;
  }

  .indicator {
    display: flex;
    padding: 4px 6px;
    align-items: center;
    gap: 4px;
    border-radius: 25px;
    border: 1px solid ${({ theme }) => theme.global.border.profit};
    width: auto;
    max-width: fit-content;
    font-size: 12px;
    font-weight: 500;
    margin-right: 10px;
    flex-grow: 1;

    &.gain {
      background: ${({ theme }) => theme.global.color.profit2};
      color: ${({ theme }) => theme.global.color.profit};
      border: 1px solid ${({ theme }) => theme.global.border.profit};

      svg {
        fill: #03cd17;
      }
    }

    &.loss {
      background-color: ${({ theme }) => theme.global.bg.loss};
      border: 1px solid ${({ theme }) => theme.global.border.loss};
    }
  }

  .dashboard-item {
    .label {
      display: flex;
      gap: 8px;
      align-items: end;

      p {
        margin: 0px;
        color: ${({ theme }) => theme.input.placeholder.secondary};
        font-size: 14px;
        font-weight: 400;
      }
    }

    .value {
      color: ${({ theme }) => theme.card.font.tertiary};
      font-size: 30px;
      font-weight: 400;
    }

    .total-output {
      display: flex;
      font-size: 14px;
      gap: 6px;
      align-items: center;

      .total-return {
        font-size: 15px;

        &.gain {
          color: ${({ theme }) => theme.global.color.profit};
        }
        &.loss {
          color: ${({ theme }) => theme.constants.COLOR_RED};
        }
      }

      .placeholder {
        min-height: 1.8em;
      }
    }

    span {
      color: #888;
    }
  }

  .chart-col {
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: 1300px) {
    .dashboard-item .value {
      font-size: 20px;
    }
  }

  @media screen and (max-width: 1100px) {
    .dashboard-item .value {
      font-size: 16px;
    }
  }

  @media screen and (max-width: 768px) {
    .separator {
      border: 0;
      padding-bottom: 20px;
    }

    .dashboard-item .value {
      font-size: 20px;
    }
  }

  @media screen and (max-width: 1300px) {
    .dashboard-row .dashboard-item .value {
      font-size: 20px;
    }
  }

  @media screen and (max-width: 1100px) {
    .dashboard-row .dashboard-item .value {
      font-size: 16px;
    }
  }

  @media screen and (max-width: 925px) and (min-width: 768px) {
    .dashboard-row {
      gap: 1rem;
      padding: 24px 0px;

      .separator {
        border: 0;
      }

      .dashboard-item .value {
        font-size: 20px;
      }

      .col-md-4 {
        width: 100%;
      }
    }

    .balance-section {
      padding: 24px 0px;

      .chart-col,
      .col-md-7 {
        display: block;
        width: 100%;
      }

      .dashboard-item .value {
        font-size: 20px;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .dashboard-row {
      gap: 1rem;
      padding: 24px 0px;

      .separator {
        border: 0;
      }

      .dashboard-item .value {
        font-size: 20px;
      }
    }

    .balance-section {
      padding: 24px 0px;

      .dashboard-item .value {
        font-size: 20px;
      }
    }
  }
`;

export const TotalReturnContainer = styled.div`
  padding: 20px 0px;
  background: #ffffff;
`;

export const ViewPortfolioHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .portfolio-title {
    color: rgba(10, 13, 18, 0.9);
    font-family: "Geist", sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 1.5em;
    margin: 0;
  }

  .button-group {
    display: flex;
    align-items: center;
    height: 28px;
    border-radius: 8px;
    border: 1px solid #d5d7da;
    overflow: hidden; /* ensure children respect rounded corners */
    /* Shadows/shadow-xs-skeuomorphic */
    box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
      0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px rgba(10, 13, 18, 0.05);

    .button-option {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
      padding: 2px 12px;
      cursor: pointer;
      /* add separators only between items to avoid double borders at ends */
      border-right: none;
      background: #ffffff; /* Unactive */
      color: #717680;
      font-family: "Geist", sans-serif;
      font-weight: 500;
      font-size: 12px;
      line-height: 1.5em;
      transition: all 0.2s ease;

      &:not(:last-child) {
        border-right: 1px solid #d5d7da;
      }

      &.active {
        background: #fafafa; /* Active */
        color: #252b37;
      }

      &:hover:not(.active) {
        background: rgba(250, 250, 250, 0.5);
      }
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  @media (max-width: 1200px) {
    .mobile-view-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      .mobile-view-inner-section {
        width: 100%;
        justify-content: space-between;
        flex-direction: row;
      }
    }
  }
`;

export const ChartTopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;

export const ConnectBrokerButton = styled.button`
  border-radius: var(--radius-md, 8px);
  border: 1px solid #d5d7da;
  background: #fff;
  padding: 8px 12px;
  font-size: 12px;
  color: rgba(10, 13, 18, 0.7);
  cursor: pointer;

  &:hover {
    background: #fafafa;
  }
`;

export const PortfolioChipsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 0px;
`;

export const PortfolioChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid ${({ $isActive }) => ($isActive ? "#D5D7DA" : "#D5D7DA")};
  background: ${({ $isActive }) => ($isActive ? "#F5F5F5" : "#ffffff")};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ $isActive }) => ($isActive ? "#D5D7DA" : "#D5D7DA")};
    background: ${({ $isActive }) => ($isActive ? "#F5F5F5" : "#ffffff")};
  }

  img {
    width: 16px;
    height: 16px;
    border-radius: 9px;
  }

  span {
    font-size: 12px;
    color: #414651;
  }
`;

export const PopoverStyles = styled.div`
  .popover {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    margin-top: 4px !important;
    pointer-events: none;
    position: fixed !important;

    .popover-body {
      padding: 0 !important;
      background: transparent !important;
      pointer-events: auto;
    }

    .popover-arrow {
      display: none !important;
    }
  }
`;

export const PortfolioDropdownContainer = styled.div`
  position: relative;
  padding: 8px 0px;
  z-index: 1;
`;

export const PortfolioDropdownTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 6px 10px 6px 12px;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  background: #ffffff;
  color: #181d27;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5em;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #fafafa;
    border-color: #d5d7da;
  }

  &:focus {
    outline: none;
    border-color: #d5d7da;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
  }

  .dropdown-content {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    img {
      width: 18px;
      height: 18px;
      border-radius: 9px;
      flex-shrink: 0;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-word;
      line-height: 1.5em;
      max-height: 1.5em;
    }
  }

  .dropdown-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    flex-shrink: 0;

    svg {
      transition: transform 0.2s ease;
    }

    &.open {
      transform: rotate(180deg);
    }
  }
`;

export const PortfolioDropdownMenu = styled.div`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  box-shadow: 0px 2px 2px -1px rgba(10, 13, 18, 0.04),
    0px 4px 6px -2px rgba(10, 13, 18, 0.03),
    0px 12px 16px -4px rgba(10, 13, 18, 0.08);
  min-width: 280px;
  max-height: 300px;
  display: flex;
  flex-direction: column;
  animation: slideDown 0.2s ease-out;
  transform-origin: top center;
  position: absolute;
  z-index: 1050;
  top: -2px;
  left: -1px;
  @media (max-width: 786px) {
    right: -145px;
    left: auto;
  }
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

export const PortfolioDropdownMenuItems = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
  min-height: 0;
`;

export const PortfolioDropdownMenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 1px 6px;
  border-radius: 6px;
  cursor: pointer;
  gap: 8px;
  color: #181d27;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5em;
  transition: background-color 0.2s ease;

  &:hover {
    background: #fafafa;
  }

  img {
    width: 18px;
    height: 18px;
    border-radius: 9px;
    flex-shrink: 0;
  }

  span {
    flex: 1;
    font-size: 14px;
    color: #181d27;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-word;
    line-height: 1.5em;
    max-height: 1.5em;
    transition: color 0.2s ease;
    font-family: "Geist", sans-serif;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background: #f5f5f5;

      & > span {
        color: rgb(34, 88, 241);
      }
    `}
`;

export const PortfolioViewAllButton = styled.div`
  padding: 8px;
  margin: 4px 8px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  background: #ffffff;
  z-index: 1;

  button {
    width: 100%;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 8px 12px;
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #181d27;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #fafafa;
    }

    &.active {
      background: #f5f5f5;
      color: #181d27;
    }
  }
`;
